export var FONT_FAMILY_BASE = '"Source Sans Pro", sans-serif';
export var FONT_FAMILY_SUPER_HEADING = '"Playfair Display", serif';
export var FONT_FAMILY_HEADING = 'Montserrat, sans-serif';
export var PAGE_FLUID_CONTAINER_MAX_WIDTH = 1224;
export var PAGE_FLUID_CONTAINER_PADDING_HORIZONTAL = {
  xs: 16,
  md: 24,
  lg: 28,
  xl: 32
};
export var PAGE_CONTAINER_WIDTH = {
  xs: 'calc(100vw - 32px)',
  sm: '540px',
  md: '720px',
  lg: '960px',
  xl: '1140px'
};
export var ICON_SIZE = {
  xs: 20,
  lg: 22,
  xl: 24
};
export var ICON_LARGE_SIZE = {
  xs: 28,
  lg: 30,
  xl: 32
};
export var ICON_SMALL_SIZE = {
  xs: 16,
  lg: 18,
  xl: 20
};
export var ICON_TINY_SIZE = {
  xs: 12,
  sm: 14,
  lg: 16
};
export var ICON_DEFAULT_SIZE = 24;
export var INFO_WITH_ICONS_MARGIN = {
  xs: 8,
  sm: 12
};
export var INFO_WITH_ICONS_LARGE_MARGIN = {
  xs: 8,
  md: 12,
  xl: 16
};
export var INFO_WITH_ICONS_MEDIUM_MARGIN = {
  xs: 6,
  md: 8,
  xl: 10
};
export var INFO_WITH_ICONS_SMALL_MARGIN = {
  xs: 4,
  md: 6,
  lg: 8,
  xl: 10
};
export var INFO_WITH_ICONS_TINY_MARGIN = {
  xs: 2,
  md: 3,
  lg: 4
};
export var CARD_BORDER_RADIUS_EXTRA_LARGE = {
  xs: 15,
  md: 20
};
export var CARD_BORDER_RADIUS_LARGE = {
  xs: 5,
  sm: 10,
  lg: 15
};
export var CARD_BORDER_RADIUS_MEDIUM = {
  xs: 5,
  sm: 10
};
export var CARD_BORDER_RADIUS_SMALL = 4;
export var CARD_BUTTON_SIZE = {
  xs: 32,
  md: 36,
  xl: 40
};
export var CARD_WIDGET_BORDER_WIDTH = {
  xs: 2,
  sm: 2,
  md: 3,
  lg: 4,
  xl: 5
};
export var CARD_WIDGET_WIDTH = {
  xs: '100%',
  sm: '100%',
  md: 166,
  lg: 188,
  xl: 212
};
export var CARD_WIDGET_SIZE = {
  xs: 100,
  sm: 116,
  md: 116,
  lg: 152,
  xl: 212
};
export var HERO_LINE_HEIGHT = [70, 72, 82, 84, 104];
export var TOOLTIP_BLUR_RADIUS = 4;
export var DRAWER_BLUR_RADIUS = 6;
export var TRUSTPILOT_CAROUSEL_CHEVRON_TOP_POSITION = [66, 74, 80, 82, 86];
export var TRUSTPILOT_DEFAULT_PROFILE_IMAGE_URL = 'https://tourlane-ui.imgix.net/images/review-avatar.png';
export var SUITE_DEFAULT_BACKGROUND_IMAGE_URL = 'https://tourlane-ui.imgix.net/images/auth/suite-background.png';
export var HOOKS_TAP_MAX_DELAY = 500;
export var HOOKS_TAP_TOLERANCE = 10;
export var HOOKS_CLICK_TOLERANCE = 5;
export var HOOKS_SWIPE_TOLERANCE = 5;
export var MAP_SCRIPT_LIBRARIES = ['geometry', 'drawing', 'places'];
export var MAP_SCRIPT_VERSION = '3.exp';
export var MENU_SIDE_WIDTH = [64, 64, 64, 72, 80];
export var MENU_TOP_HEIGHT = [48, 54, 72, 72, 80];
export var MENU_SHOW_DESKTOP = [false, false, false, true, true];
export var MENU_SHOW_MOBILE = [true, true, true, false, false];
export var CARD_ACCOMMODATION_WIDTH = [244, 262, 284, 302, 308];
export var DOT_SIZE = 11;
export var ACCORDION_IMAGE_HEIGHT = [180, 324, 432, 558, 676];
export var ACCORDION_CONTENT_MARGIN = [-84, -148, -192, -200, -236]; // A project-wide registry for z-indices

export var Z_INDEX_MAP = {
  base: 0,
  map: 100,
  bottomMenu: 300,
  topMenu: 400,
  tab: 500,
  bar: 600,
  drawer: 800,
  modal: 1000,
  fullScreen: 2000,
  picker: 3000,
  menu: 3000,
  tooltip: 4000,
  notification: 5000
};